import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import api from '../services/api';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!username || !password) {
      setErrorMsg('Please enter both username and password.');
      return;
    }
    setErrorMsg('');
    setLoading(true);

    try {
      const data = new FormData();
      data.append('username', username);
      data.append('password', password);

      const response = await api.post('/token', data);
      const { access_token } = response.data;
      localStorage.setItem('jwt_token', access_token);
      navigate('/dashboard');
    } catch (error) {
      console.error(error);
      setErrorMsg('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      p={2}
    >
      <Box 
        component="form" 
        onSubmit={handleLogin} 
        width={{ xs: '90%', sm: '300px' }}
        p={4}
        boxShadow={3}
        bgcolor="white"
        borderRadius={2}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Admin Login
        </Typography>
        <TextField 
          label="Username" 
          variant="outlined"
          fullWidth
          margin="normal"
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
        />
        <TextField 
          label="Password" 
          type="password" 
          variant="outlined"
          fullWidth
          margin="normal"
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
        />
        {errorMsg && (
          <Alert severity="error" sx={{ my: 2 }}>
            {errorMsg}
          </Alert>
        )}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
        </Button>
      </Box>
    </Box>
  );
}
